import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { useBoardChartData } from '../../hooks/useBoardChartData';
import { BaseChartProps } from './types';
import { CHART_COLORS, CHART_STYLES } from './chartTheme';
import { useSetChartMetadata } from './ChartContext';

export const AdApprovalTrackerChart: React.FC<BaseChartProps> = () => {
    const { t } = useTranslation();
    const { events, isLoading } = useBoardChartData();

    const chartData = useMemo(() => {
        if (!events) return [];

        const approved = events.filter((e: any) => (e.type || e.eventType) === 'ad_review_approved').length;
        const declined = events.filter((e: any) => (e.type || e.eventType) === 'ad_review_declined').length;

        if (approved === 0 && declined === 0) return [];

        const data = [];
        if (approved > 0) data.push({ name: t('charts.approved', 'Approved'), value: approved, color: CHART_COLORS.revenue });
        if (declined > 0) data.push({ name: t('charts.rejected', 'Rejected'), value: declined, color: CHART_COLORS.danger });
        return data;
    }, [events, t]);

    const isEmpty = !isLoading && chartData.length === 0;
    useSetChartMetadata({ isEmpty });

    return (
        <div className="w-full h-full bg-transparent overflow-hidden flex flex-col">
            <div className="flex-1 min-h-0 p-2">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie data={chartData} cx="50%" cy="50%" innerRadius="40%" outerRadius="65%" dataKey="value" label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`} labelLine={false}>
                            {chartData.map((entry, i) => (
                                <Cell key={i} fill={entry.color} />
                            ))}
                        </Pie>
                        <Tooltip contentStyle={CHART_STYLES.tooltip.contentStyle} />
                        <Legend wrapperStyle={{ fontSize: '10px' }} />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};
